// [NEW] One place for "show lists A to Z". Ignores case and accents; numbers compare as numbers ("E2" before "E10").
const collator = new Intl.Collator(undefined, { numeric: true, sensitivity: "base" });

export const compareText = (a, b) => collator.compare(String(a ?? "").trim(), String(b ?? "").trim());

// Returns a sorted COPY. by = property name ("name") or a function (row) => text. Default: "name".
export function sortAlpha(list, by = "name") {
  const get = typeof by === "function" ? by : (row) => row?.[by];
  return [...(list || [])].sort((a, b) => compareText(get(a), get(b)));
}
